import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <Container sx={{ py: 8, minHeight:'80vh' }}>
      <Typography variant="h4" gutterBottom>
        <Trans i18nKey="privacyPolicy.title">Privacy Policy</Trans>
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
          {t('privacyPolicy.content', 'Privacy Policy content goes here...')}
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
